import React, {Fragment} from 'react';

import {getSpoonerism} from '../../constants/tests.js';
import StopWatch from '../../components/StopWatch';
import AdminTestPanel from '../../components/AdminTestPanel';
import AdminReadyButton from '../../components/AdminReadyButton';
import {updateStepData} from '../../api';
import strings from '../../strings';
import CountDown from 'components/CountDown';

class SpoonerismAdmin extends AdminTestPanel {
	constructor(props) {
		super(props, {
			stopOnConsecutiveErrors: false,
			enableHotkeys: true,
			key: 1,
		});
	}

	getTestName = () => {
		return strings.sp_testname;
	};
	updateTimeUsed = (timeUsed) => {
		let skipTime = this.state.skipTime;

		if (skipTime == timeUsed) {
			const newSkipTime = 30 + timeUsed;
			this.setState({
				timeElapsedLasAnsnwer: timeUsed,
				timeUsed: timeUsed,
				skipTime: newSkipTime,
			});
			this.answerWrong();
		} else
			this.setState({
				timeUsed: timeUsed,
				timeElapsedLasAnsnwer: timeUsed,
			});
	};

	handleKeyPress = (event) => {
		const {
			options: {limitHotkeysToTest, enableHotkeys},
			currentStage,
		} = this.state;

		if ((!limitHotkeysToTest || currentStage === 0) && enableHotkeys) {
			if (event.key === 'a') {
				this.answer(2);
				this.handleCountdownComplete();
			}
			if (event.key === 'l') {
				this.answer(1);
				this.handleCountdownComplete();
			}
			if (event.key === 'k') {
				this.answer(0);
				this.handleCountdownComplete();
			}
		} else if (
			(!limitHotkeysToTest || currentStage === 1) &&
			enableHotkeys
		) {
			if (
				event.key === 'a' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerCorrect(2);
			}
			if (
				event.key === 'l' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerCorrect(1);
			}
			if (
				event.key === 'k' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerWrong();
			}
		}
	};

	answer = (numberOfCorrect) => {
		if (numberOfCorrect === 2) {
			updateStepData({
				answered: true,
				correct: true,
				feedbackDone: false,
			});
		} else
			updateStepData({
				answered: true,
				correct: false,
				feedbackDone: false,
			});
	};

	componentWillReceiveProps(newProps) {
		super.componentWillReceiveProps(newProps);

		if (
			newProps.stepData.feedbackDone &&
			!this.props.stepData.feedbackDone &&
			newProps.stepData.answered
		) {
			this.answerCorrect();
		}
	}

	getTask = (currentStep) => {
		return getSpoonerism().getIntroSteps()[currentStep].task;
	};
	getCorrect = (currentStep) => {
		return getSpoonerism().getIntroSteps()[currentStep].correct;
	};
	handleCountdownComplete = () => {
		this.setState((prevState) => ({
			key: prevState.key < 20 ? prevState.key + 1 : 1,
		}));
	};
	renderIntro = () => {
		const {currentStep, candidateReady} = this.state;
		return (
			<Fragment>
				{currentStep === 0 && (
					<Fragment>
						<p>
							{strings.formatString(
								strings.sp_admin1,
								<i
									style={{
										color: 'yellow',
										fontWeight: 'bold',
									}}
								>
									{strings.sp_example1}
								</i>
							)}
						</p>
						<p>{strings.sp_admin1part2}</p>
						<AdminReadyButton
							isPractiseTasks
							remoteIsReady={candidateReady}
							onClick={this.props.nextStep}
						/>
					</Fragment>
				)}
				{currentStep > 0 && currentStep < 4 && (
					<Fragment>
						<p>{strings.practiceTasks}</p>
						<p>
							{strings.formatString(
								strings.taskNum,
								this.getTask(currentStep)
							)}
						</p>
						<p>
							{strings.formatString(
								strings.expectedAnswer,
								this.getCorrect(currentStep)
							)}
						</p>
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(2);
							}}
						>
							{strings.sp_2correct}
						</button>
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(1);
							}}
						>
							{strings.sp_1correct}
						</button>
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(0);
							}}
						>
							{strings.sp_bothWrong}
						</button>
					</Fragment>
				)}
				{currentStep === 4 && (
					<Fragment>
						<p>{strings.sp_admin2}</p>
						<p>{strings.clickStartWhenReady}</p>
						<AdminReadyButton
							remoteIsReady={candidateReady}
							onClick={this.props.nextStage}
						/>
					</Fragment>
				)}
			</Fragment>
		);
	};

	renderTest = () => {
		const {currentStep} = this.state;
		const steps = getSpoonerism().getSteps();
		return (
			<div>
				<div className="lit-stop-watch-div">
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
				</div>
				<p>
					<br />
					{strings.sp_admin_listen}
					<br />
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						steps.length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.taskNum,
						steps[currentStep].task
					)}
				</p>
				<p>
					{strings.formatString(
						strings.expectedAnswer,
						<b>{steps[currentStep].correct}</b>
					)}
				</p>
				<div className="lit-all-buttons-div">
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect(2);
						}}
					>
						{strings.sp_2correct}
					</button>
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect(1);
						}}
					>
						{strings.sp_1correct}
					</button>
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerWrong();
						}}
					>
						{strings.sp_bothWrong}
					</button>
					<div className="lit-count-down-div">
						{this.state.timeElapsedLasAnsnwer + 30 !==
							this.state.skipTime && (
							<CountDown
								key={this.state.key}
								duration={30}
								onComplete={this.handleCountdownComplete}
							/>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderWaiting = () => {
		return (
			<div>
				<p>
					{strings.formatString(
						strings.testDoneAndFinished,
						strings.sp_testname
					)}
				</p>
				<Fragment>
					<button onClick={this.props.nextStage}>
						{strings.getLanguage() === 'de'
							? 'Nächste'
							: strings.endTest}
					</button>
				</Fragment>
			</div>
		);
	};
}

export default SpoonerismAdmin;
